const PREFIX_APP = "CAPCO_ADMIN_";

export const LOCAL_STORAGE_KEY = {
  ACCESS_TOKEN: PREFIX_APP + "ACCESS_TOKEN"
};

export const POPPO_URL = process.env.REACT_APP_POPPO_URL;

/**
 * Build/deploy smoke-test version shown at /healthcheck-fe.
 * Bump this (or set REACT_APP_BUILD_VERSION at build time) to confirm a new deploy is live.
 */
export const APP_VERSION = process.env.REACT_APP_BUILD_VERSION || "2026-09-03-v1";

/**
 * Default empty value displayed when data is missing or unavailable.
 * Used throughout the application to maintain consistency in displaying empty/null values.
 *
 * Usage examples:
 * - Display "-" when personal information fields are empty
 * - Show "-" in table cells when data is not available
 * - Used in ApplicationsDetailPersonalInfo, ApplicationsDetailResidents, and other detail components
 *
 * @example
 * const displayValue = user.name || DEFAULT_EMPTY_VALUE;
 */
export const DEFAULT_EMPTY_VALUE = "-";

/**
 * Character threshold for displaying tooltips on text fields.
 * When text length exceeds this value, a tooltip will be shown on hover to display the full text.
 *
 * Usage:
 * - Used with TextWithTooltip utility component
 * - Applied to fields like email addresses, phone numbers, and long text in tables
 * - Helps maintain clean UI while providing access to full content
 *
 * @example
 * <span>{TextWithTooltip(email, TOOLTIP_THRESHOLD)}</span>
 */
export const TOOLTIP_THRESHOLD = 15;

// Common constants
export const AREA_OPTIONS = [
  { value: "札幌", label: "札幌" },
  { value: "仙台", label: "仙台" },
  { value: "東京", label: "東京" },
  { value: "名古屋", label: "名古屋" },
  { value: "大阪", label: "大阪" },
  { value: "福岡", label: "福岡" }
];

export const PREFECTURE_OPTIONS = [
  { code: "01", value: "北海道", label: "北海道", kana: "ホッカイドウ" },
  { code: "02", value: "青森県", label: "青森県", kana: "アオモリケン" },
  { code: "03", value: "岩手県", label: "岩手県", kana: "イワテケン" },
  { code: "04", value: "宮城県", label: "宮城県", kana: "ミヤギケン" },
  { code: "05", value: "秋田県", label: "秋田県", kana: "アキタケン" },
  { code: "06", value: "山形県", label: "山形県", kana: "ヤマガタケン" },
  { code: "07", value: "福島県", label: "福島県", kana: "フクシマケン" },
  { code: "08", value: "茨城県", label: "茨城県", kana: "イバラキケン" },
  { code: "09", value: "栃木県", label: "栃木県", kana: "トチギケン" },
  { code: "10", value: "群馬県", label: "群馬県", kana: "グンマケン" },
  { code: "11", value: "埼玉県", label: "埼玉県", kana: "サイタマケン" },
  { code: "12", value: "千葉県", label: "千葉県", kana: "チバケン" },
  { code: "13", value: "東京都", label: "東京都", kana: "トウキョウト" },
  { code: "14", value: "神奈川県", label: "神奈川県", kana: "カナガワケン" },
  { code: "15", value: "新潟県", label: "新潟県", kana: "ニイガタケン" },
  { code: "16", value: "富山県", label: "富山県", kana: "トヤマケン" },
  { code: "17", value: "石川県", label: "石川県", kana: "イシカワケン" },
  { code: "18", value: "福井県", label: "福井県", kana: "フクイケン" },
  { code: "19", value: "山梨県", label: "山梨県", kana: "ヤマナシケン" },
  { code: "20", value: "長野県", label: "長野県", kana: "ナガノケン" },
  { code: "21", value: "岐阜県", label: "岐阜県", kana: "ギフケン" },
  { code: "22", value: "静岡県", label: "静岡県", kana: "シズオカケン" },
  { code: "23", value: "愛知県", label: "愛知県", kana: "アイチケン" },
  { code: "24", value: "三重県", label: "三重県", kana: "ミエケン" },
  { code: "25", value: "滋賀県", label: "滋賀県", kana: "シガケン" },
  { code: "26", value: "京都府", label: "京都府", kana: "キョウトフ" },
  { code: "27", value: "大阪府", label: "大阪府", kana: "オオサカフ" },
  { code: "28", value: "兵庫県", label: "兵庫県", kana: "ヒョウゴケン" },
  { code: "29", value: "奈良県", label: "奈良県", kana: "ナラケン" },
  { code: "30", value: "和歌山県", label: "和歌山県", kana: "ワカヤマケン" },
  { code: "31", value: "鳥取県", label: "鳥取県", kana: "トットリケン" },
  { code: "32", value: "島根県", label: "島根県", kana: "シマネケン" },
  { code: "33", value: "岡山県", label: "岡山県", kana: "オカヤマケン" },
  { code: "34", value: "広島県", label: "広島県", kana: "ヒロシマケン" },
  { code: "35", value: "山口県", label: "山口県", kana: "ヤマグチケン" },
  { code: "36", value: "徳島県", label: "徳島県", kana: "トクシマケン" },
  { code: "37", value: "香川県", label: "香川県", kana: "カガワケン" },
  { code: "38", value: "愛媛県", label: "愛媛県", kana: "エヒメケン" },
  { code: "39", value: "高知県", label: "高知県", kana: "コウチケン" },
  { code: "40", value: "福岡県", label: "福岡県", kana: "フクオカケン" },
  { code: "41", value: "佐賀県", label: "佐賀県", kana: "サガケン" },
  { code: "42", value: "長崎県", label: "長崎県", kana: "ナガサキケン" },
  { code: "43", value: "熊本県", label: "熊本県", kana: "クマモトケン" },
  { code: "44", value: "大分県", label: "大分県", kana: "オオイタケン" },
  { code: "45", value: "宮崎県", label: "宮崎県", kana: "ミヤザキケン" },
  { code: "46", value: "鹿児島県", label: "鹿児島県", kana: "カゴシマケン" },
  { code: "47", value: "沖縄県", label: "沖縄県", kana: "オキナワケン" }
];

export interface AccountTypeOption {
  value: number;
  label: string;
}

export const ACCOUNT_TYPE_OPTIONS: AccountTypeOption[] = [
  { value: 1, label: "普通" },
  { value: 2, label: "当座" }
];

// Variable Cost
export const getStatusBadgeVariableCostClass = (status: number) => {
  switch (status) {
    case 1:
      return "status-default";
    case 2:
      return "status-pending";
    case 4:
      return "status-pending";
    case 7:
      return "status-approved";
    case 9:
      return "status-approved";
    case 99:
      return "status-rejected";
  }
};

export const getStatusTextVariableCost = (status: number) => {
  switch (status) {
    case 1:
      return "下書き";
    case 2:
      return "申請中";
    case 4:
      return "審査中";
    case 7:
      return "承認済み";
    case 9:
      return "処理済み";
    case 99:
      return "却下";
  }
};

// Contract
export const getStatusBadgeContractClass = (status: string, type: "contract" | "entry") => {
  const baseClass = "status-badge";

  if (type === "contract") {
    switch (Number(status)) {
      case 1:
        return `${baseClass} status-pending`;
      case 4:
        return `${baseClass} status-cancelled`;
      case 5:
        return `${baseClass} status-active`;
      case 6:
        return `${baseClass} status-expired`;
      default:
        return baseClass;
    }
  } else {
    switch (status) {
      case "moved_in":
        return `${baseClass} status-moved-in`;
      case "not_moved_in":
        return `${baseClass} status-not-moved-in`;
      case "moved_out":
        return `${baseClass} status-moved-out`;
      default:
        return baseClass;
    }
  }
};

export const getStatusTextContract = (status: string, type: "contract" | "entry") => {
  if (type === "contract") {
    switch (Number(status)) {
      case 1:
        return "審査中";
      case 4:
        return "追加書類";
      case 5:
        return "契約締結";
      case 6:
        return "キャンセル";
      default:
        return status;
    }
  } else {
    switch (status) {
      case "moved_in":
        return "入居中";
      case "not_moved_in":
        return "未入居";
      case "moved_out":
        return "退去済み";
      default:
        return status;
    }
  }
};

// Applications
export const getStatusBadgeApplicationsClass = (status: string) => {
  switch (Number(status)) {
    // Completed / positive
    case 5: // 契約締結
    case 51: // 承認
    case 52: // 契約開始日確定
      return "status-completed";

    // Reviewing
    case 1: // 審査中
    case 8:
      return "status-reviewing";

    // Pending
    case 2: // 連保要請
    case 3: // 未記入あり
    case 4: // 追加書類
      return "status-pending";

    // Rejected / negative
    case 6: // キャンセル
    case 7: // 不可
    case 9: // 保証対象外
      return "status-rejected";

    default:
      return "status-default";
  }
};

// Leave Applications
export const getStatusBadgeLeaveApplicationsClass = (status: string) => {
  switch (Number(status)) {
    // pending
    case 1: // 未処理
      return "bg-[#6b7280]";

    // approved
    case 2: // 承認
      return "bg-[#059669]";

    // rejected
    case 3: // 却下
      return "bg-[#dc2626]";

    default:
      return "bg-[#6b7280]";
  }
};

export const REVIEW_STATUS = {
  TEMP_SAVE: "", // 一時保存中
  TEMP_SAVE_AFFILIATE: "0",
  JUDGE: "1", // 審査中
  REQUEST: "2", // 連保要請
  BLANK: "3", // 未記入あり
  FLAW: "4", // 追加書類
  APPROVED: "51", // 承認
  AFFILIATE_CONFIRMED: "52", // 契約開始日確定
  COMP: "5", // 契約締結
  CANCEL: "6", // キャンセル
  REJECT: "7", // 却下
  OUTER: "9" // 保証対象外
} as const;

export const FIRST_GUARANTEE_FEE_INVOICE = 18;
export const CLOUDSIGN_SIGNED_PDF = 25;
export const CLOUDSIGN_CERTIFICATE_PDF = 26;
export const CLOUDSIGN_COMPLETED_DOCUMENT_TYPES = [CLOUDSIGN_SIGNED_PDF, CLOUDSIGN_CERTIFICATE_PDF] as const;
export const isCloudSignCompletedDocumentType = (type: number): boolean =>
  CLOUDSIGN_COMPLETED_DOCUMENT_TYPES.some((completedType) => completedType === type);
export const LEASE_CONTRACT_DOCUMENT = 27;
export const FIRE_INSURANCE_DOCUMENT = 33;
export const SPECIAL_TERMS_DOCUMENT = 28;
export const APPLICATION_REVIEW_DOCUMENT = 29;
export const MIN_AMOUNT_FILE = 1;
export const MAX_AMOUNT_FILE = 99;
export type ReviewStatusValue = (typeof REVIEW_STATUS)[keyof typeof REVIEW_STATUS];
export const AUTHLEVEL = {
  EDITABLE: 1,
  VIEWONLY: 2,
  NOT_ACCESS: 3
};

export const KATAKANA_ONLY_REGEX = /[^ァ-ヶーｦ-ﾟ\s]/g;
